import type { Consent } from "@ng-mw/shared-react-components/src/modules/consents/types/Consent"

const ANALYTICAL_CONSENT = {
    type: "CONFIRM",
    channelCode: "ZCU",
}

export const getAnalyticalConsent = (consents: Consent[]): Consent | undefined =>
    consents.find(
        consent =>
            consent.itemType === "CONSENT" &&
            consent.chainId === "133" &&
            consent.type === ANALYTICAL_CONSENT.type &&
            consent.channelCode === ANALYTICAL_CONSENT.channelCode,
    )

export const getAnalyticalConsentStatus = (consents: Consent[]): boolean =>
    getAnalyticalConsent(consents)?.status === "true"
